import { RESET_SNACKBAR, SET_SNACKBAR } from '@app/store/constants';
import { ISnackbarState } from '@app/models';

export function handleSetSnackbar(snackbar: ISnackbarState) {
    return {
        payload: snackbar,
        type: SET_SNACKBAR
    };
}

export function handleResetSnackbar() {
    return {
        type: RESET_SNACKBAR
    };
}